<template>
  <div>
    <h3>Expert Mode</h3>
    <div class="expert-mode">
      <information class="mt-1">
        Expert mode enables additional advanced features within the add-in, and
        should only be used with care.
      </information>
      <switch-field
        v-model="enabled"
        id="enable-expert-mode"
        label="Enable Expert Mode"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Information from "@/components/common/banners/Information.vue";

export default {
  components: { Information },
  computed: {
    ...mapState({
      expertMode: (state) => state.expertMode,
    }),
    enabled: {
      get: function() {
        return this.expertMode;
      },
      set: function(enable) {
        this.enableExpertMode(enable);

        if (enable) {
          this.logInfo("User has enabled expert mode.");
        } else {
          this.logInfo("User has disabled expert mode.");
        }
      },
    },
  },
  methods: {
    ...mapActions({
      enableExpertMode: "enableExpertMode",
    }),
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bold;
}
</style>
